import { render, staticRenderFns } from "./BarMain.vue?vue&type=template&id=ac51c766"
import script from "./BarMain.vue?vue&type=script&lang=ts"
export * from "./BarMain.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports